import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import Features from "./components/Features";
import TodoShowcaseSection from "./components/TodoShowcaseSection";
import HowItWorks from "./components/HowItWorks";
import { Box } from "@mui/material";
import Footer from "./components/Footer";
import CookieConsentBanner from "./components/CookieConsentBanner";
import PrivacyPolicy from "./components/PrivacyPolicy";
import BlogPage from "./components/BlogPage";
import BlogPostDetail from "./components/BlogPostDetail";
import { motion } from "framer-motion";

// Main landing page component
const LandingPage: React.FC = () => (
  <>
    <Navbar />
    <Box
      component="main"
      sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <HeroSection />
      <Features />
      <TodoShowcaseSection />
      <HowItWorks />
      <Footer />
    </Box>
  </>
);

const App: React.FC = () => {
  return (
    <Router>
      <Box
        component={motion.div}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        sx={{
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostDetail />} />
        </Routes>
        <CookieConsentBanner />
      </Box>
    </Router>
  );
};

export default App;
